import loadable from '@loadable/component'

export const EsgScroller = loadable(() => import('./EsgScroller'))
export const ESGRelevance = loadable(() => import('./ESGRelevance'))
export type { ESGRelevanceProps } from './ESGRelevance'
export type { EsgScrollerProps } from './EsgScroller'
